import { z } from "zod";
/**
 * Staff users live in Clerk. The app owns only the role metadata used
 * by RBAC, so this schema deliberately models an invitation/grant
 * operation rather than a local staff-user database row.
 */
export const StaffRoleSchema = z.enum(["admin", "exec", "sales", "board"]);
export const StaffUserListQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(500).default(100),
    offset: z.coerce.number().int().min(0).default(0),
});
export const StaffUserSchema = z.object({
    id: z.string().min(1),
    email: z.string().email().toLowerCase().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    role: StaffRoleSchema.nullable(),
    rawRole: z.string().nullable(),
    createdAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime().nullable(),
});
export const StaffUserListResponseSchema = z.object({
    users: z.array(StaffUserSchema),
    totalCount: z.number().int().nonnegative(),
    hasMore: z.boolean(),
    missingRoleCount: z.number().int().nonnegative(),
});
export const StaffUserCreateSchema = z.object({
    email: z.string().email().toLowerCase(),
    role: StaffRoleSchema.default("sales"),
    notify: z.boolean().default(true),
    redirectUrl: z.string().url().max(500).optional(),
});
export const StaffUserCreateResponseSchema = z.object({
    email: z.string().email().toLowerCase(),
    role: StaffRoleSchema,
    status: z.enum(["existing", "invited"]),
    previousRole: StaffRoleSchema.nullable().optional(),
    userId: z.string().min(1).optional(),
    invitationId: z.string().min(1).optional(),
    invitationUrl: z.string().url().optional(),
});
//# sourceMappingURL=staff-users.js.map